// import React from 'react'
// import { Trash2 } from "lucide-react";

// function QuestionList({categories , handelDeleteCategory}) {
//   return (
//    <>
//     <div className="question-category-container">
//         <h1 className="question-category-title">Question Category List</h1>
//         <div className="question-category-button-container"></div>
//         <ul className="question-category-list">
//           {categories.map((item, index) => (
//             <React.Fragment key={index}>
//               <li className="question-category-list-item">
//                 {item.name}
// {!item.isPreData &&
//  < Trash2  onClick={()=>handelDeleteCategory(item._id)} className="question-category-trash-icon" />
// }
//               </li>
//               {item.questions && (
//                 <ul className="question-category-sublist">
//                   {item.questions.map((question, index) => (
//                     <li key={index} className="question-category-subitem">
//                       {question}
//                     </li>
//                   ))}
//                 </ul>
//               )}
//             </React.Fragment>
//           ))}
//         </ul>
//       </div>
//    </>
//   )
// }

// export default QuestionList
import React, { useState } from "react";
import { Trash2 } from "lucide-react";

function QuestionList({ categories, handelDeleteCategory }) {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAccordion = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };
  // console.log(categories,"categories======")
  return (
    <>
      <div className="question-category-container">
        <h1 className="question-category-title">Question Category List</h1>
        <div className="accordion">
          {categories.map((category, index) => (
            <div className="accordion-item" key={category._id}>
              <div
                className={`accordion-header ${activeIndex === index ? "active" : ""
                  }`}
                onClick={() => toggleAccordion(index)}
              >
                {category.name} — {category.questions?.length || 0} Questions
                {!category.isPreData && (
                  <Trash2
                    onClick={(e) => {
                      e.stopPropagation();
                      handelDeleteCategory(category._id);
                    }}
                    className="question-category-trash-icon"
                    style={{ float: "right" }}
                  />
                )}
              </div>
              <div
                className="accordion-body"
                style={{ display: activeIndex === index ? "block" : "none" }}
              >
                {category.questions?.map((question, qIndex) => {
                  return (
                    <div className="question-item" key={qIndex}>
                      <div className="question-text">
                        <strong>{qIndex + 1}.</strong> {question}
                        {category.answers?.length > 0 && (
                          <ul className="question-response-options">
                            {category.answers.map((answer) => (
                              <li key={answer._id}>
                                {answer.name} ({answer.value} point
                                {answer.value !== 1 ? "s" : ""})
                              </li>
                            ))}
                          </ul>
                        )}
                      </div>
                      <div className="question-actions">
                        <button onClick={() => console.log('Edit Q', index, qIndex)}>
                          <i className="fas fa-edit" />
                        </button>
                        <button onClick={() => console.log('Delete Q', index, qIndex)}>
                          <i className="fas fa-trash-alt" />
                        </button>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}

export default QuestionList;
